import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import { red } from '@mui/material/colors';
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import ModeEditOutlineRoundedIcon from '@mui/icons-material/ModeEditOutlineRounded';
import Modal from "@mui/material/Modal";
import "../Dashboard.css";
import "../Components/SideMenu.css";
import SideMenu from "../Components/SideMenu";
import "mdb-ui-kit/css/mdb.min.css";
import AddSectionsForm from "./AddSectionsForm";

import CircularIndeterminate from '../../GeneralComponents/CirularProgress'
import StyledDataGrid from '../../GeneralComponents/StyledDataGrid'
import "../../../../assets/css/DG.css"
import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import swal from 'sweetalert'
import axios from 'axios'
import ApiSettings from "../.././../../Settings/ApiSettings.json";

import { useGlobalContext } from '../../../../context'
import UpdateSection from "./UpdateSection";
import ViewClass from "./Classes/ViewClass";
import Cookies from "universal-cookie";
const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
};



export default function AddSections(props) {
  const [inactive, setInactive] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  const [pageNumber, setpageNumber] = useState(1);
  const [classsTotal, setClasssTotal] = useState(0)
  const [classsNumberOfPages, setClasssNumberOfPages] = useState(0)
  const [showBoxOfEditForm, setshowBoxOfEditForm] = useState(false);
  const [showBoxOfViewForm, setshowBoxOfViewForm] = useState(false);
  const [selectedObject, setSelectedObject] = useState(null);
  const { loading,  sections, fetchData } = useGlobalContext()
  //   const [openSnackbar, setopenSnackbar] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });
  const [columns] = useState([
    { field: 'id', headerName: 'ت', flex: .1 },

    { field: 'name', headerName: 'الاسم', flex: 1 },

    {
      field: 'actions', flex: .2,
      headerName: 'الادوات',
      renderCell: (rows) => (
        <strong>


          <IconButton
            style={{ marginLeft: 15 }}
            aria-label="عرض"
            size="small"
            onClick={() => {
              viewObject(rows.row)
            }}
          >
            <Tooltip title="View">
              <RemoveRedEyeRoundedIcon color="primary" />
            </Tooltip>
          </IconButton>

          <IconButton
            style={{ marginLeft: 15 }}
            aria-label="تعديل"
            size="small"
            onClick={() => {
              updateObject(rows.row)

            }}
          >
            <Tooltip title="Edit">
              <ModeEditOutlineRoundedIcon style={{ fill: "#deb12c" }} />
            </Tooltip>
          </IconButton>

          <IconButton
            style={{ marginLeft: 20 }}
            aria-label="مسح"
            size="small"
            onClick={() => {
              //TODO delete object
              softDelete(rows?.row)
            }}
          >
            <Tooltip title="Delete">
              <DeleteRoundedIcon sx={{ color: red[500] }} />
            </Tooltip>
          </IconButton>
        </strong>
      ),
    },
  ]);

  const [rows, setRow] = useState([])
  const handlePageChange = (newPage) => {
    setpageNumber(newPage + 1)
  }

  const updateObject = async (object) => {
    setSelectedObject(object)

    setshowBoxOfEditForm(true)
  };
  const viewObject = async (object) => {
    setSelectedObject(object)
    setshowBoxOfViewForm(true)
  };
  const advanceSearch = () => {

    fetchData('SECTIONS', 'sections', {
      page: pageNumber,
      page_size: pageSize,
    });
  }
  useEffect(() => {

    advanceSearch()

  }, [pageSize, pageNumber])
  //Reformatting classs object once classs are loaded
  useEffect(() => {
    console.log("hi");
    console.log(sections);
    if (sections && sections.data && sections.data.length > 0) {

      const reformatData = sections.data.map((rowClass) => {
        return {
          id: rowClass.id,
          name: rowClass.name,

        }
      })
      console.log(reformatData);
      setRow(reformatData);
      setClasssTotal(sections.total)
      setClasssNumberOfPages(sections.last_page)
    }
  }, [sections])

    //here we will sent request with data to deleted it from database.
  const softDelete = async (object) => {

      // setLoading(true);
      swal({
        title: "هل انت متأكد?",
        text: "بمجرد حذفك للعنصر لن يكون بامكانك استاعدته!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then(async(willDelete) => {
        if (willDelete) {
      let data = null;
      try {
        data = await axios({
          method: "delete",
          url: ApiSettings.apiUrl + "/sections/" + object.id,
  
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-localization": 'ar'
          },
        });
  
        console.log("delete", data);
        if (data) {
          if (data.data.status == 200) {
            // setLoading(false);
  
            setsnackBar({
              ...snackBar,
              message: data.data.message,
              severity: "success",
              open: true,
            });
            advanceSearch()
          } else if (data.data.status == 402) {
            //   alert(data.data.data.name);
            setsnackBar({
              ...snackBar,
              message: data.data.data.name,
              severity: "warning",
              open: true,
            });
          } else {
            //   alert(data.data.message);
            setsnackBar({
              ...snackBar,
              message: data.data.message,
              severity: "warning",
              open: true,
            });
          }
          // setLoading(false);
        }
      } catch (err) {
        //   alert(err.message);
        setsnackBar({
          ...snackBar,
          message: err.message,
          severity: "error",
          open: true,
        });
        // setLoading(false);
      }
    }})
  
  
    };



  return (
    <div className="Dashboard_MOF px-0 mx-0">

      <div className="container-fluid h-100 w-100 mx-0 px-0">
        <div className="row rowContainer mx-0">
          <div className="col-md-12 col-xl-12 height-100 w-100 d-flex flex-column justify-content-center align-items-end  paddingForm">
            <AddSectionsForm inactive={props.inactive} advanceSearch={advanceSearch}  />

            <div
              className={`FormContainer  ${props.inactive === false ? "activeSideMenu" : ""
                }`}
              style={{ height: '400px' ,borderRadius:10}}>

              <StyledDataGrid
                rows={rows}
                columns={columns}
                rowCount={sections?.total ? sections?.total : 0}
                pageSize={pageSize}
                page={pageNumber - 1}
                onPageSizeChange={(newPageSize) => {
                  setPageSize(newPageSize)
                }}

                components={{
                  Footer: () => null,
                }}
                rowsPerPageOptions={[5, 10, 20]}
                // pagination
                paginationMode="server"
                onPageChange={(params) => {
                  handlePageChange(params)
                }}
              />
              <Box width="45%" m="auto" sx={{ direction: 'ltr' }}>
                <Pagination
                  color="primary"
                  size="large"
                  count={classsNumberOfPages}
                  page={pageNumber}
                  showFirstButton
                  showLastButton
                  onChange={(e, p) => {
                    setpageNumber(p)
                  }}
                />
              </Box>

              <div style={{ width: '50%', position: 'absolute', top: '100px', margin: '0 auto', left: '50%', top: '50%' }}>
                {loading && (
                  <CircularIndeterminate />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        keepMounted
        open={showBoxOfEditForm || showBoxOfViewForm}
        onClose={() => {
          setshowBoxOfEditForm(false);
          setshowBoxOfViewForm(false);
        }}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{
            border: "none",
            outline: "none",
            borderRadius: "10px",
            overflow: "scroll",
          }}
          className="modalCroupsCarrier"
        >
          {selectedObject && showBoxOfEditForm &&
            <UpdateSection object={selectedObject} advanceSearch={()=>advanceSearch()} />}
          {selectedObject && showBoxOfViewForm &&
          
            <ViewClass object={selectedObject}  />}
        </Box>
      </Modal>
    </div>
  );
}
